import { asyncHandler } from '../../async-handler';
import store from '../../../../store/store';
import { RequestInfo } from '../../../../interfaces/RequestInfo';
import { USER_CHANNELS_API } from '../../../constants/central-api';
import { applicationJSONBodyBuilder } from '../../../utils/body-builder';

export default async function create_communication_channel_api_call(
  bodyContent: any
) {
  const userID = store.getState().user.profile?.user_id;
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: `${USER_CHANNELS_API(userID)}`,
    method: 'POST',
    body: applicationJSONBodyBuilder(bodyContent),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'CREATE_COMMUNICATION_CHANNEL';
  const customMsg = 'Channel created successfully';

  const res: any = await asyncHandler(requestInfo, actionType, customMsg, true);
  const response = res?.data;

  if (res.actionType === actionType && response.success === true) {
    return true;
  } else {
    return false;
  }
}
